module.exports = __webpack_public_path__ + "img/sattelit.6e082fa5.png";